<template>
  <div>
    <b-breadcrumb>
      <b-breadcrumb-item>USTED ESTA AQUI</b-breadcrumb-item>
      <b-breadcrumb-item active>Administración --> Clientes</b-breadcrumb-item>
    </b-breadcrumb>
    <h2 class="page-title">Administrar - <span class="fw-semi-bold">Clientes</span></h2>

    <vs-popup title="Crear Cliente" :active.sync="popupNewCompanyActive">
        <Widget  customHeader>
                <div style="margin-left:20px">
                    <b-row>
                        <b-col lg="6" sm="6" xs="12">
                            <div class="vx-row">
                                <div class="vx-col sm:w-1/2 w-full mb-2">
                                    <label>Nombre Cliente</label>
                                    <input class="form-control no-border" 
                                     ref="nameNewCompany" />
                                </div>
                            </div>
                            <div class="vx-row">
                                <div class="vx-col sm:w-1/2 w-full mb-2">
                                    <label>Dirección Cliente</label>
                                    <input class="form-control no-border"
                                     ref="addressNewCompany" />
                                </div>
                            </div>
                            <div class="vx-row">
                                <div class="vx-col sm:w-1/2 w-full mb-2">
                                    <label>Logo Cliente</label>
                                     <div class="large-12 medium-12 small-12 cell">
                                      <label>Cargar..
                                        <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" />
                                      </label>
                                      <button v-on:click="submitFile()">CARGAR</button>
                                    </div>
                                    <div class="large-12 medium-12 small-12 cell">
                                      <img name="img_new_logo" id="img_new_logo"  style="max-width:50px;height:50px" />
                                    </div>
                                </div>
                            </div>
                        </b-col>
                        <b-col lg="6" sm="6" xs="12">
                            <div class="vx-row">
                                <div class="vx-col sm:w-1/2 w-full mb-2">
                                    <label>Teléfono 1</label>
                                    <input class="form-control no-border"
                                       data-vv-validate-on="none" v-model="this.edit_telephone1_company" ref="tel1NewCompany" />
                                </div>
                                <div class="vx-col sm:w-1/2 w-full mb-2">
                                    <label>Teléfono 2</label>
                                    <input type="email" class="form-control no-border"  
                                    v-model="this.edit_telephone2_company" ref="tel2NewCompany"/>
                                </div>
                                <div class="vx-col sm:w-1/2 w-full mb-2">
                                    <label>Correo</label>
                                    <input class="form-control no-border" 
                                    v-model="this.edit_email_company" ref="emailNewCompany"/>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <vs-divider/>
                    <div class="vx-row">
                        <div style="text-align:right" class="vx-col w-full">
                            <vs-button class="mr-3 mb-2" @click="saveCompany">Guardar</vs-button>
                            <vs-button color="warning" type="border" class="mb-2" @click="closePopPupNewCompany">Cancelar</vs-button>
                        </div>
                    </div>
                </div>
        </Widget>
    </vs-popup>
    
    <vs-popup title="Editar Cliente" :active.sync="popupEditActive">
        <Widget  customHeader>
                <div style="margin-left:20px" >
                    <b-row>
                        <b-col lg="6" sm="6" xs="12">
                            <div class="vx-row">
                                <div class="vx-col sm:w-1/2 w-full mb-2">
                                    <label>ID Cliente</label>
                                    <input class="form-control no-border"
                                    disabled v-model="this.edit_id_company" />
                                </div>
                                <div class="vx-col sm:w-1/2 w-full mb-2">
                                    <label>Nombre Cliente</label>
                                    <input class="form-control no-border" 
                                    v-model="this.edit_name_company" ref="nameCompany" />
                                </div>
                            </div>
                            <div class="vx-row">
                                <div class="vx-col sm:w-1/2 w-full mb-2">
                                    <label>Dirección</label>
                                    <input class="form-control no-border"  label-placeholder="Dirección" 
                                    v-model="this.edit_address_company" ref="addressCompany" />
                                </div>
                            </div>
                             <div class="vx-row">
                                <div class="vx-col sm:w-1/2 w-full mb-2">
                                    <label>Logo</label>
                                    <td><img style="max-width:75px;height:50px" :src="this.edit_logo_company"/></td>
                                </div>
                            </div>
                        </b-col>
                        <b-col lg="6" sm="6" xs="12">
                            <div class="vx-row">
                                <div class="vx-col sm:w-1/2 w-full mb-2">
                                    <label>Teléfono 1</label>
                                    <input class="form-control no-border"
                                        v-model="this.edit_telephone1_company" ref="tel1Company" />
                                </div>
                                <div class="vx-col sm:w-1/2 w-full mb-2">
                                    <label>Teléfono 2</label>
                                    <input type="email" class="form-control no-border"  
                                    v-model="this.edit_telephone2_company" ref="tel2Company"/>
                                </div>
                                <div class="vx-col sm:w-1/2 w-full mb-2">
                                    <label>Correo</label>
                                    <input class="form-control no-border" 
                                    v-model="this.edit_email_company" ref="emailCompany"/>
                                </div>
                                <label>Activo:     </label>
                                <input style="margin-left:10px;margin-top:5px" type="checkbox" 
                                :checked="this.edit_status_company_check" ref="statusCompany"/>
                            </div>
                        </b-col>
                    </b-row>
                    <vs-divider/>
                    <div class="vx-row">
                        <div style="text-align:right" class="vx-col w-full">
                            <vs-button class="mr-3 mb-2" @click="editCompany">Guardar</vs-button>
                            <vs-button color="warning" type="border" class="mb-2" @click="closePopPupEditCompany">Cancelar</vs-button>
                        </div>
                    </div>
                </div>
        
        </Widget>
    </vs-popup>

    <vs-popup title="Eliminar Cliente" :active.sync="popupDeleteActive">
        <Widget  customHeader>
                <div style="margin-left:20px" >
                    <b-row>
                        <b-col lg="12" sm="6" xs="12">
                            <div class="vx-row">
                                <h4 class="page-title">Está seguro que desea darle de baja al cliente 
                                    <span class="fw-semi-bold">{{this.edit_name_company}} ?</span></h4>
                            </div>
                        </b-col>
                    </b-row>
                    <vs-divider/>
                    <div class="vx-row">
                        <div style="text-align:right" class="vx-col w-full">
                            <vs-button class="mr-3 mb-2" @click="deleteCompany">Eliminar</vs-button>
                            <vs-button color="warning" type="border" class="mb-2" 
                            @click="closePopPupDeleteCompany">Cancelar</vs-button>
                        </div>
                    </div>
                </div>
        </Widget>
    </vs-popup>

    <p><b-button
            variant="success" id="show-success-message" @click="openPopPupNewCompany"
          >+ Agregar Nuevo Cliente +</b-button></p>

    <table class="table table-striped">
           <thead>
             <tr>
               <th>ID</th>
               <th>CLIENTE</th>
               <th>DIRECCION</th>
               <th>TELEFONO</th>
               <th>CORREO</th>
               <th>LOGO</th>
               <th>ESTADO</th>
               <th>EDITAR</th>
               <th>BORRAR</th>
             </tr>
           </thead>
           <tbody>
             <tr v-for="row in myJson" :key="row.id_company">
               <td>{{row.id_company}}</td>
               <td>{{row.name_company}}</td>
               <td>{{row.address_company}}</td>
               <td>{{row.telephone1}}</td>
               <td>{{row.email}}</td>
               <td><img style="max-width:50px;height:35px" :src="row.src"/></td>
               <td>
                   <b-badge v-if="row.status_company == 1" variant="success">Activo</b-badge>
                   <b-badge v-else variant="gray">Inactivo</b-badge>
               </td>
               <td><b-button variant="success" class="p-1 px-3 btn-xs" 
                    @click="openPopPupEditCompany(row.id_company+'|'+row.name_company+'|'+row.address_company+'|'+row.telephone1+'|'+row.telephone2+'|'+row.email+'|'+row.status_company+'|'+row.src)" >Editar</b-button></td>
               <td><b-button variant="danger" class="p-1 px-3 btn-xs" 
                    @click="openPopPupDeleteCompany(row.id_company+'|'+row.name_company+'|'+row.address_company+'|'+row.telephone1+'|'+row.telephone2+'|'+row.email+'|'+row.status_company)">Borrar</b-button></td>
             </tr>
           </tbody>
         </table>
  </div>
</template>

<script>

/* eslint-disable */
import 'imports-loader?jQuery=jquery,this=>window!flot';
import 'imports-loader?jQuery=jquery,this=>window!flot/jquery.flot.pie';
/* eslint-enable */



import Widget from '@/components/Widget/Widget';

import Media from '@dongido/vue-viaudio';

import axios from "axios";

import 'imports-loader?$=jquery,this=>window!messenger/build/js/messenger'; // eslint-disable-line

const currentDate = new Date()

const { Messenger } = window;

function initializationMessengerCode() {
  (function () {
    let $,
      FlatMessage,
      spinner_template,
      __hasProp = {}.hasOwnProperty,
      __extends = function (child, parent) {
        for (const key in parent) {
          if (__hasProp.call(parent, key)) child[key] = parent[key];
        }

        function ctor() {
          this.constructor = child;
        }

        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
        child.__super__ = parent.prototype;
        return child;
      };

    $ = jQuery;

    spinner_template = '<div class="messenger-spinner">\n    <span class="messenger-spinner-side messenger-spinner-side-left">\n        <span class="messenger-spinner-fill"></span>\n    </span>\n    <span class="messenger-spinner-side messenger-spinner-side-right">\n        <span class="messenger-spinner-fill"></span>\n    </span>\n</div>';

    FlatMessage = (function (_super) {
      __extends(FlatMessage, _super);

      function FlatMessage() {
        return FlatMessage.__super__.constructor.apply(this, arguments);
      }

      FlatMessage.prototype.template = function (opts) {
        let $message;
        $message = FlatMessage.__super__.template.apply(this, arguments);
        $message.append($(spinner_template));
        return $message;
      };

      return FlatMessage;
    }(Messenger.Message));

    Messenger.themes.air = {
      Message: FlatMessage,
    };
  }).call(window);
};

export default {
  name: 'abcEmpresas',
  components: { Widget,Media},
  data() {
    return {
      
      file: "",

      myJson: null,
      popupEditActive: false,
      popupDeleteActive: false,
      popupNewCompanyActive: false,

      //TO EDIT COMPANY
      edit_id_company: 0,
      edit_name_company: "",
      edit_address_company: "",
      edit_logo_company: "",
      edit_logo_company_name: "",
      logo_new_company: "",
      edit_telephone1_company: "",
      edit_telephone2_company: "",
      edit_email_company: "",
      edit_status_company: 0,
      edit_status_company_check: false,
    
      edit_insert_id_country: "",
      editNameCountry: "",

      edit_insert_name_company: "",
      edit_insert_address_company: "",
      edit_insert_location_company: "",
      edit_insert_telephone1_company: "",
      edit_insert_telephone2_company: "",
      edit_insert_email_company: "",

      locationClasses: 'messenger-fixed messenger-on-top messenger-on-center',
    };
  },
  methods: {

    handleFileUpload(){
      this.file = this.$refs.file.files[0];
      this.logo_new_company = this.file.name;
      //alert(this.file.name);

    },

  submitFile(){
        
            let file_name = this.logo_new_company;

            

            let formData = new FormData();
            formData.append('file', this.file);

            axios.post( 'http://3.232.184.255:8080/upload_logo_company',
            //axios.post( 'http://localhost:8080/upload_logo_company',
                formData,
                {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
              }
            ).then(function(){
              alert("EL ARCHIVO HA SIDO CARGADO CON EXITO");
              
              //alert("https://corpolex-docs.s3.amazonaws.com/"+file_name);
               
              document.getElementById("img_new_logo").src = "https://corpolex-docs.s3.amazonaws.com/"+file_name;
        })
        .catch(function(){
          //console.log('FAILURE!!');
        });
      },

      getURL(){

        //return "https://corpolex-docs.s3.amazonaws.com/"+this.logo_new_company;
       

      },

    getCompanies(){
       //axios.post('http://3.232.184.255:8000/corpolex-get_companies', "{no-data}", 
     // axios.post('http://localhost:8080/corpolex-get_companies', "{no-data}", 
      axios.post('http://3.232.184.255:8080/corpolex-get_companies_0', "{no-data}",
      {
          headers: {
          'i_c': '1'
        }
      }).then(r => 
        {
          this.myJson = r.data;
          //window.localStorage.setItem('json_vids', JSON.stringify(this.myJson));
          console.log('JSON-COMPANIES',this.myJson)
        }),
        error => {
                console.log(r);
                console.log(error);
            }; 
    },


    openPopPupEditCompany(text){
        
        var split = text.split("|");
        
        this.edit_id_company = split[0];
        this.edit_name_company = split[1];
        this.edit_address_company = split[2];
        this.edit_telephone1_company = split[3];
        this.edit_telephone2_company = split[4];
        this.edit_email_company = split[5];
        this.edit_status_company = split[6];

        this.edit_logo_company = split[7];
        
        this.edit_logo_company_name = this.edit_logo_company.substring(this.edit_logo_company.indexOf(".com/") + 5 ); 

        //alert(this.edit_logo_company_name);

        if(this.edit_status_company == "1"){
            this.edit_status_company_check = true
        }
        else{this.edit_status_company_check = false}

        this.popupEditActive = true;
    },

    openPopPupNewCompany(){
        this.popupNewCompanyActive = true;
    },

    openPopPupDeleteCompany(text){
        
        var split = text.split("|");
        
        this.edit_id_company = split[0];
        this.edit_name_company = split[1];
        this.edit_address_company = split[2];
        this.edit_telephone1_company = split[3];
        this.edit_telephone2_company = split[4];
        this.edit_email_company = split[5];
        this.edit_status_company = split[6];
        
        if(this.edit_status_company == "1"){
            this.edit_status_company_check = true
        }
        else{this.edit_status_company_check = false}

        this.popupDeleteActive = true;
    },
    closePopPupEditCompany(){
        this.popupEditActive = false;
    },
     closePopPupNewCompany(){
        this.popupNewCompanyActive = false;
    },
    closePopPupDeleteCompany(){
        this.popupDeleteActive = false;
    },
    editCompany(){

        //alert(this.edit_logo_company_name);

         axios.post('http://3.232.184.255:8080/edit_corpolex_company', "{no-data}", 
        // axios.post('http://localhost:8080/edit_corpolex_company', "{no-data}", 
      {
          headers: {
          'Content-type': 'application/x-www-form-urlencoded',
          'i_c': this.edit_id_company,
          'n_c': this.$refs.nameCompany.value,
          'a_c': this.$refs.addressCompany.value,
          't1_c': this.$refs.tel1Company.value,
          't2_c': this.$refs.tel2Company.value,
          'e_c': this.$refs.emailCompany.value,
          'l_c': this.edit_logo_company_name,
          's_c': this.$refs.statusCompany.value,

        }
      }).then(r => 
        {
            this.myJson = r.data;
            console.log(this.myJson)
            
            if (this.myJson[0].state_code == 'DONE') {
              this.popupEditActive = false;
              this.addDoneNotification()
              this.getCompanies();
            }
            else{
              this.addErrorNotification();
            }
        }),
        error => {
                console.log(r);
                console.log(error);
            }; 
    },
    saveCompany(){

     // this.$validator.validateAll().then(success => {

         axios.post('http://3.232.184.255:8080/new_corpolex_company', "{no-data}", 
         //axios.post('http://localhost:8080/new_company', "{no-data}", 
      {
          headers: { 
          'Content-type': 'application/x-www-form-urlencoded',
          
          //VALUES TO INSERT
          'n_c': this.$refs.nameNewCompany.value,
          'a_c': this.$refs.addressNewCompany.value,
          't1_c': this.$refs.tel1NewCompany.value,
          't2_c': this.$refs.tel2NewCompany.value,
          'e_c': this.$refs.emailNewCompany.value,
          'l_c': this.logo_new_company,
         
        }
      }).then(r => 
        {
            this.myJson = r.data;
            console.log(this.myJson)
            
            if (this.myJson[0].state_code == 'INSERTED') {
              this.popupNewCompanyActive = false
              this.addDoneNotification()
              this.getCompanies();
            }
            else{
              this.addErrorNotification();
            }
        }),
        error => {
                console.log(r);
                console.log(error);
            }; 
     // })
    },
    deleteCompany(){
         axios.post('http://3.232.184.255:8080/delete_corpolex_company', "{no-data}", 
         //axios.post('http://localhost:8080/delete_corpolex_company', "{no-data}", 
      {
          headers: {
          'Content-type': 'application/x-www-form-urlencoded',
          'i_c': this.edit_id_company
        }
      }).then(r => 
        {
            this.myJson = r.data;
            console.log(this.myJson)
            
            if (this.myJson[0].state_code == 'DONE') {
              this.popupDeleteActive = false;
              this.addDoneDeleteNotification()
              this.getCompanies();
            }
            else{
              this.addErrorNotification();
            }
        }),
        error => {
              console.log(r);
              console.log(error);
            }; 
    },
  
    //NOTIFICATIONS
    addErrorNotification() {
        Messenger().post({
          message: 'Ha ocurrido un error al guardar los cambios',
          type: 'error',
          showCloseButton: true
        });
    },
    addDoneNotification() {
        Messenger().post({
          message: 'Se han guardado los cambios para al cliente ' + this.edit_name_company + ' con éxito.',
          type: 'success',
          showCloseButton: true
        });
    },
    addDoneDeleteNotification() {
        Messenger().post({
          message: 'Se ha dado de baja al cliente ' + this.edit_name_company + ' con éxito.',
          type: 'success',
          showCloseButton: true
        });
    },
  },
  
  mounted() {
      this.getCompanies();
  },
  created(){
    initializationMessengerCode();

    Messenger.options = {
      extraClasses: this.locationClasses,
      theme: 'air',
    };
  }
};
</script>


